<template>
  <div class="boxlr">
    <div class="contentBox" :class="{ darkBox: dark, 'img_left': left_img }">
      <div class="imgBox" v-show="left_img">
        <v-img :src="require('../assets/images/'+ data.src)" Contain width='100%'></v-img>
      </div>
      <div class="textBox">
        <v-row justify="center" align="center" v-show="data.content.title" style="margin:20px 0">
          <h1 :class="dark?'text-justify font-weight-thin mb-4 third_title white--text':'text-justify font-weight-thin mb-4 third_title'" v-html='data.content.title'>
          </h1>
        </v-row>
        <div style="display:flex;" v-show="data.content.body">
          <p :class="dark?'text-justify body_text white--text':'text-justify body_text'" style="text-align:center;margin:auto;" v-html="data.content.body">
          </p>
        </div>
        <v-list dense color="rgba(1,1,1,0)" v-show="data.content.list.length>=1">
          <v-list-item v-for="i in data.content.list" :key="i.index">
            <v-list-item-icon v-show='!hide_icon'>
              <v-img width='6' height='6' v-if='i.src' :src="require('../assets/images/'+ i.src)"></v-img>
              <v-icon v-else size="6" :color="dark?'white':'primary'">mdi-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                <p v-html="i.title" :class="dark?'body_text white--text':'body_text'" v-show='i.title' style="line-height:1.5"></p>
              </v-list-item-title>
              <v-list-item-subtitle>
                <p v-html="i.subtitle" :class="dark?'body_text white--text':'vody_text'" v-show='i.subtitle'></p>
              </v-list-item-subtitle>
              <p v-html="i.body" :class="dark?'body_text white--text':'body_text'" v-show='i.body'></p>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div class="btn_box" v-show="data.content.btn">
          <v-btn outlined color="primary" class="btn-blue" :to="data.content.btn.path">{{data.content.btn.label}}</v-btn>
        </div>
      </div>
      <div class="imgBox" v-show="!left_img">
        <v-img :src="require('../assets/images/'+ data.src)" Contain width='100%'></v-img>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'box-lr',

  props: {
    left_img: Boolean,
    dark: Boolean,
    data: Object,
    hide_icon: Boolean
  },
  created () {
    this.$nextTick(() => {
      // console.log(this.data)
    })
  },
  data: () => ({

  })

}
</script>

<style>

</style>
